import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NoteModule } from '../../../../../note/note.module';
import { SharedPipesModule } from '../../../../../shared/pipes/shared-pipes.module';
import { VehicleDetailsComponent } from './vehicle-details.component';

@NgModule({
    declarations: [
        VehicleDetailsComponent
    ],
    imports: [
        CommonModule,
        NoteModule,
        SharedPipesModule
    ],
    exports: [
        VehicleDetailsComponent
    ]
})
export class VehicleDetailsModule {
}
